import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts'

import { useState } from 'react'
import React from 'react'

// const dataWithWithdrawals = [
//   { year: 2000, actual: 219750, lowToHigh: 150000, highToLow: 323475 },
//   { year: 2001, actual: 186122, lowToHigh: 109350, highToLow: 417837 },
//   { year: 2002, actual: 137489, lowToHigh: 88848, highToLow: 530173 },
//   { year: 2003, actual: 169421, lowToHigh: 73263, highToLow: 662957 },
//   { year: 2004, actual: 180354, lowToHigh: 62554, highToLow: 800180 },
//   { year: 2005, actual: 181709, lowToHigh: 55917, highToLow: 920709 },
//   { year: 2006, actual: 202901, lowToHigh: 49597, highToLow: 1058589 },
//   { year: 2007, actual: 206540, lowToHigh: 44532, highToLow: 1210513 },
//   { year: 2008, actual: 122620, lowToHigh: 39477, highToLow: 1368732 },
//   { year: 2009, actual: 147566, lowToHigh: 36272, highToLow: 1524932 },
//   { year: 2010, actual: 162289, lowToHigh: 33111, highToLow: 1683345 },
//   { year: 2011, actual: 158213, lowToHigh: 30144, highToLow: 1768260 },
//   { year: 2012, actual: 176027, lowToHigh: 27183, highToLow: 1847582 },
//   { year: 2013, actual: 225543, lowToHigh: 23975, highToLow: 1879066 },
//   { year: 2014, actual: 248919, lowToHigh: 20311, highToLow: 1897497 },
//   { year: 2015, actual: 244854, lowToHigh: 17245, highToLow: 1806887 },
//   { year: 2016, actual: 266639, lowToHigh: 14308, highToLow: 1634960 },
//   { year: 2017, actual: 317346, lowToHigh: 10912, highToLow: 1433063 },
//   { year: 2018, actual: 295947, lowToHigh: 6848, highToLow: 1108856 },
//   { year: 2019, actual: 381640, lowToHigh: 1567, highToLow: 691079 },
// ]

// const dataNoWithdrawals = [
//   { year: 2000, actual: 227250, lowToHigh: 157500, highToLow: 330975 },
//   { year: 2001, actual: 200230, lowToHigh: 122693, highToLow: 435199 },
//   { year: 2002, actual: 155979, lowToHigh: 108104, highToLow: 560014 },
//   { year: 2003, actual: 200714, lowToHigh: 98267, highToLow: 708194 },
//   { year: 2004, actual: 222552, lowToHigh: 93963, highToLow: 862793 },
//   { year: 2005, actual: 233479, lowToHigh: 95259, highToLow: 1000839 },
//   { year: 2006, actual: 270345, lowToHigh: 97269, highToLow: 1158872 },
//   { year: 2007, actual: 285187, lowToHigh: 102045, highToLow: 1333398 },
//   { year: 2008, actual: 179668, lowToHigh: 107648, highToLow: 1515940 },
//   { year: 2009, actual: 227208, lowToHigh: 119360, highToLow: 1697247 },
//   { year: 2010, actual: 261426, lowToHigh: 133635, highToLow: 1881907 },
//   { year: 2011, actual: 266942, lowToHigh: 151930, highToLow: 1985224 },
//   { year: 2012, actual: 309652, lowToHigh: 174810, highToLow: 2082698 },
//   { year: 2013, actual: 409949, lowToHigh: 202413, highToLow: 2126643 },
//   { year: 2014, actual: 466071, lowToHigh: 234799, highToLow: 2155991 },
//   { year: 2015, actual: 472503, lowToHigh: 286056, highToLow: 2061558 },
//   { year: 2016, actual: 529014, lowToHigh: 361746, highToLow: 1873957 },
//   { year: 2017, actual: 644498, lowToHigh: 465495, highToLow: 1651143 },
//   { year: 2018, actual: 616269, lowToHigh: 612079, highToLow: 1286241 },
//   { year: 2019, actual: 810332, lowToHigh: 810332, highToLow: 810332 },
// ]

function generatePortfolioData(startingValue, withdrawal = 0) {
  const actualReturns = [
    -9.1, -11.89, -22.1, 28.68, 10.88, 4.91, 15.79, 5.49, -37.0, 26.46, 15.06,
    2.11, 16.0, 32.39, 13.69, 1.38, 11.96, 21.83, -4.38, 31.49,
  ]

  const lowToHighReturns = [...actualReturns].sort((a, b) => a - b)
  const highToLowReturns = [...actualReturns].sort((a, b) => b - a)

  let actualBalance = startingValue
  let lowToHighBalance = startingValue
  let highToLowBalance = startingValue

  const dataWithWithdrawals = []

  // Add starting point for 1999
  dataWithWithdrawals.push({
    year: 1999,
    actual: Math.round(startingValue),
    lowToHigh: Math.round(startingValue),
    highToLow: Math.round(startingValue),
  })

  for (let i = 0; i < actualReturns.length; i++) {
    const year = 2000 + i

    actualBalance = actualBalance * (1 + actualReturns[i] / 100) - withdrawal
    lowToHighBalance =
      lowToHighBalance * (1 + lowToHighReturns[i] / 100) - withdrawal
    highToLowBalance =
      highToLowBalance * (1 + highToLowReturns[i] / 100) - withdrawal

    dataWithWithdrawals.push({
      year,
      actual: Math.round(actualBalance),
      lowToHigh: Math.round(lowToHighBalance),
      highToLow: Math.round(highToLowBalance),
    })
  }

  return dataWithWithdrawals
}

const dollarAbbrevFormat = (value) => {
  if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`
  if (value >= 1_000) return `$${(value / 1_000).toFixed(0)}k`
  return `$${value}`
}

export default function SequenceReturn({
  showHigh = false,
  showLow = false,
  showActual = false,
  withdrawals = false,
  data = [],
  startingValue = 250000,
  withdrawalAmount = 7500,
}) {
  const [showHighToLow, setShowHighToLow] = useState(showHigh)
  const [showLowToHigh, setShowLowToHigh] = useState(showLow)
  const [showActualLine, setShowActualLine] = useState(showActual)

  const dataWithWithdrawals = generatePortfolioData(
    startingValue,
    withdrawalAmount
  )
  const dataNoWithdrawals = generatePortfolioData(startingValue)

  return (
    <>
      <div style={{ marginBottom: 16, marginRight: 16 }}>
        <button
          onClick={() => {
            setShowHighToLow(true)
            setShowLowToHigh(true)
            setShowActualLine(true)
          }}
        >
          Show All
        </button>

        <button
          onClick={() => {
            setShowHighToLow(false)
            setShowLowToHigh(false)
            setShowActualLine(false)
          }}
          style={{ marginLeft: 8 }}
        >
          Hide All
        </button>
      </div>
      <div style={{ marginBottom: 16 }}>
        <button onClick={() => setShowHighToLow(!showHighToLow)}>
          {showHighToLow ? 'Hide' : 'Show'} High to Low
        </button>
        <button
          onClick={() => setShowLowToHigh(!showLowToHigh)}
          style={{ marginLeft: 8 }}
        >
          {showLowToHigh ? 'Hide' : 'Show'} Low to High
        </button>
        <button
          onClick={() => setShowActualLine(!showActualLine)}
          style={{ marginLeft: 8 }}
        >
          {showActualLine ? 'Hide' : 'Show'} Actual
        </button>
      </div>

      <ResponsiveContainer width="100%" height={500}>
        <LineChart
          data={
            data.length > 0
              ? data
              : withdrawals
              ? dataWithWithdrawals
              : dataNoWithdrawals
          }
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="year"
            label={{ value: 'Year', position: 'insideBottomRight', offset: -5 }}
            tick={{}}
          />
          <YAxis tickFormatter={(v) => dollarAbbrevFormat(v)} />
          <Tooltip formatter={(value) => dollarAbbrevFormat(value)} />
          <Legend verticalAlign="top" />

          {showHighToLow && (
            <Line
              type="linear"
              dataKey="highToLow"
              stroke="green"
              strokeWidth={3}
              dot={false}
              name="High to Low"
            />
          )}
          {showLowToHigh && (
            <Line
              type="linear"
              dataKey="lowToHigh"
              stroke="red"
              strokeWidth={3}
              dot={false}
              name="Low to High"
            />
          )}
          {showActualLine && (
            <Line
              type="linear"
              dataKey="actual"
              stroke="#1f2bfa"
              strokeWidth={3}
              dot={{ r: 5, fill: 'blue' }}
              name="Actual"
            />
          )}
        </LineChart>
      </ResponsiveContainer>
    </>
  )
}
